export const schoolProgramAttendanceHeaders = [
  {
    key: "school_name",
    label: "School",
  },
  {
    key: "day",
    label: "Day",
  },
  {
    key: "program_time",
    label: "Time",
  },
  {
    key: "program_duration",
    label: "Duration",
  },
  {
    key: "course_abbr",
    label: "Course",
  },
  {
    key: "student_id",
    label: "Student ID",
  },
  {
    key: "student_name",
    label: "Student Name",
  },
  {
    key: "parent_name",
    label: "Parent Name",
  },
  {
    key: "phone",
    label: "Phone Number",
  },
  {
    key: "sessions",
    label: "Sessions",
  },
];
